// Shared constants for Budget components
// This file centralizes all dropdown options to avoid duplication

export const STATE_OPTIONS = [
  { label: 'Enabled', value: 'enabled' },
  { label: 'Disabled', value: 'disabled' },
  { label: 'Draft', value: 'draft' },
  { label: 'Completed', value: 'completed' },
];

export const SETUP_FLOW_OPTIONS = [
  { label: 'Quick Setup', value: 'quick' },
  { label: 'Advanced Setup', value: 'advanced' },
];

export const AGENCY_INTERNAL_OPTIONS = [
  { label: 'Agency View', value: false },
  { label: 'Limitless View', value: true },
];

export const BUDGET_DRIVER_OPTIONS = [
  { label: 'Daily', value: 'daily' },
  { label: 'Monthly', value: 'monthly' },
];

export const AD_TYPE_CSV_OPTIONS = [
  { label: 'Sponsored Product and Sponsored Display', value: 'SP,SD' },
  { label: 'Sponsored Brand', value: 'SB' },
  { label: 'Sponsored Tv', value: 'ST' },
];

// AD Type groups for budget allocation - order matters!
export const AD_TYPE_GROUPS = [
  { label: 'SP + SD', value: 'SP,SD', key: 'sp_sd' },
  { label: 'SB', value: 'SB', key: 'sb' },
  { label: 'ST', value: 'ST', key: 'st' },
];

export const LIMITLESS_BUDGET_OPTIONS = [
  { label: 'Strict Budget', value: 0 },
  { label: 'No Budget', value: 1 },
  { label: 'Flexible Budget', value: 2 },
];

export const INCLUDES_OPTIONS = [
  { label: 'All ADs', value: '' },
  { label: 'Limitless ADs', value: 'limitless' },
  { label: 'Manual ADs', value: 'external' },
];

export const SPEND_PRIORITY_OPTIONS = [
  { label: 'Most Brand', value: '-2' },
  { label: 'More Brand', value: '-1' },
  { label: 'Brand and Non-Brand', value: '0' },
  { label: 'More NonBrand', value: '1' },
  { label: 'Most NonBrand', value: '2' },
];

export const SPEND_TACTIC_OPTIONS = [
  { label: 'Max Performance', value: 'max_perf' },
  { label: 'Full Budget Spend', value: 'full_spend' },
];

export const SPEND_SPEED_OPTIONS = [
  { label: 'Standard', value: 'speed_level_1' },
  { label: 'Fast', value: 'speed_level_2' },
  { label: 'Fastest', value: 'speed_level_3' },
];

export const COST_TARGET_TYPE_OPTIONS = [
  { label: 'Blended', value: 'blended' },
  { label: 'Brand/NonBrand', value: 'bnb' },
];

export const STATUS_OPTIONS = [
  { label: 'ON', value: 'ON' },
  { label: 'OFF', value: 'OFF' },
];

export const ACTIVE_DAY_OPTIONS = [
  { label: 'Monday', name: 'monday', value: '0' },
  { label: 'Tuesday', name: 'tuesday', value: '1' },
  { label: 'Wednesday', name: 'wednesday', value: '2' },
  { label: 'Thursday', name: 'thursday', value: '3' },
  { label: 'Friday', name: 'friday', value: '4' },
  { label: 'Saturday', name: 'saturday', value: '5' },
  { label: 'Sunday', name: 'sunday', value: '6' },
];

// Budget Type Options (Item, Brand, DSP, Other)
export const BUDGET_TYPE_OPTIONS = [
  { label: 'Item', value: 'item' },
  { label: 'Brand', value: 'brand' },
  { label: 'DSP', value: 'dsp' },
  { label: 'Other', value: 'other' },
];

// Item Type Options (for Item and Walmart budgets)
export const ITEM_TYPE_OPTIONS = [
  { label: 'SKU', value: 'SKU' },
  { label: 'ASIN', value: 'ASIN' },
  { label: 'ITEM', value: 'ITEM' },
];

export const ITEM_SELECTION_OPTIONS = [
  { label: 'All', value: 'ALL' },
  { label: 'Top', value: 'TOP' },
];

export const DESTINATION_OPTIONS = [
  { label: 'On', value: 'ON' },
  { label: 'Off', value: 'OFF' },
];

// Brand-specific options
// NOTE: These map to API sub-types: sbv, sbpc, sbss
// But in rolled-up views, all are displayed as generic "SB"
export const BRAND_AD_FORMAT_OPTIONS = [
  { label: 'Video', value: 'video' }, // Maps to API: sbv
  { label: 'Product Collection', value: 'product_collection' }, // Maps to API: sbpc
  { label: 'Store Spotlight', value: 'store_spotlight' }, // Maps to API: sbss
];

// Mapping of Brand Ad Formats to API sub-types
export const BRAND_AD_FORMAT_TO_API_TYPE = {
  video: 'sbv',
  product_collection: 'sbpc',
  store_spotlight: 'sbss',
};

// Reverse mapping: API sub-types to Brand Ad Formats
export const API_TYPE_TO_BRAND_AD_FORMAT = {
  sbv: 'video',
  sbpc: 'product_collection',
  sbss: 'store_spotlight',
};

// DSP-specific Item Types
export const DSP_ITEM_TYPE_OPTIONS = [
  { label: 'Product Page', value: 'product_page' },
  { label: 'Custom Landing Page', value: 'custom_landing_page' },
  { label: 'Brand Collection', value: 'brand_collection' },
  { label: 'Product Collection', value: 'product_collection' },
  { label: 'Store', value: 'store' },
];

// DSP Spend Tactics (different from Item/Brand)
export const DSP_SPEND_TACTIC_OPTIONS = [
  { label: 'ALL - Full Funnel', value: 'all_full_funnel' },
  { label: 'Top of Funnel', value: 'top_of_funnel' },
  { label: 'Middle of Funnel', value: 'middle_of_funnel' },
  { label: 'Bottom of Funnel', value: 'bottom_of_funnel' },
  { label: 'Loyalty Retargeting Funnel', value: 'loyalty_retargeting_funnel' },
];

// DSP Spend Speed (different from Item/Brand)
export const DSP_SPEND_SPEED_OPTIONS = [
  { label: 'Auto (ALL)', value: 'auto_all' },
  { label: 'AOO', value: 'aoo' },
  { label: 'APD', value: 'apd' },
  { label: '3PE', value: '3pe' },
];

// DSP Gender Targeting
export const DSP_GENDER_OPTIONS = [
  { label: 'Male and Female', value: 'male_and_female' },
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
];

// DSP Ad Format
export const DSP_AD_FORMAT_OPTIONS = [
  { label: 'Display', value: 'display' },
  { label: 'Video', value: 'video' },
];

// ==============================================================================
// PLATFORM-SPECIFIC BUDGET TYPE CONFIGURATIONS
// ==============================================================================
// This configuration drives which fields are shown in the budget group form
// based on the selected platform (retailer) and budget/ad type

export const PLATFORM_BUDGET_TYPES = {
  amazon: {
    label: 'Budget Type',
    options: [
      { label: 'Item', value: 'item', adType: null, itemType: null },
      { label: 'Brand', value: 'brand', adType: null, itemType: null },
      { label: 'DSP', value: 'dsp', adType: null, itemType: null },
      { label: 'Other', value: 'other', adType: null, itemType: null },
    ],
  },
  walmart: {
    label: 'Budget Type',
    options: [
      { label: 'Item', value: 'item', adType: null, itemType: null },
    ],
  },
  google: {
    label: 'Google Ad Type',
    options: [
      {
        label: 'Search',
        value: 'google_search',
        adType: 'SEARCH',
        itemType: 'url',
        fields: { url: true, asins: true },
      },
      {
        label: 'Performance Max',
        value: 'google_pmax',
        adType: 'PERFORMANCE MAX',
        itemType: 'url',
        fields: { url: true },
      },
      {
        label: 'Standard Shopping',
        value: 'google_shop',
        adType: 'STANDARD SHOPPING',
        itemType: 'productItemId',
        fields: { productIds: true },
      },
    ],
  },
  meta: {
    label: 'Meta Ad Type',
    options: [
      {
        label: 'Facebook Feed',
        value: 'meta_facebook',
        adType: 'FACEBOOK FEED',
        itemType: 'url',
        fields: { url: true, targeting: true },
      },
      {
        label: 'Instagram Feed',
        value: 'meta_instagram',
        adType: 'INSTAGRAM FEED',
        itemType: 'url',
        fields: { url: true, targeting: true },
      },
      {
        label: 'Audience Network',
        value: 'meta_audience_network',
        adType: 'META AUDIENCE NETWORK',
        itemType: 'url',
        fields: { url: true, targeting: true },
      },
    ],
  },
  tiktok: {
    label: 'TikTok Ad Type',
    options: [
      {
        label: 'Smart+ Catalog',
        value: 'tiktok_smart_catalog',
        adType: 'SMART+ CATALOG',
        itemType: 'productItemId',
        fields: { productIds: true },
      },
      {
        label: 'In-Feed',
        value: 'tiktok_infeed',
        adType: 'IN-FEED',
        itemType: 'url',
        fields: { url: true },
      },
      {
        label: 'TikTok Shop',
        value: 'tiktok_shop',
        adType: 'TIKTOK SHOP',
        itemType: 'productItemId',
        fields: { productIds: true },
      },
    ],
  },
};

// ==============================================================================
// GOOGLE-SPECIFIC OPTIONS
// ==============================================================================

export const GOOGLE_SALES_COUNTRY_OPTIONS = [
  { label: 'United States', value: 'US' },
  { label: 'Canada', value: 'CA' },
  { label: 'United Kingdom', value: 'GB' },
  { label: 'Germany', value: 'DE' },
  { label: 'France', value: 'FR' },
  { label: 'Japan', value: 'JP' },
  { label: 'Australia', value: 'AU' },
  { label: 'Mexico', value: 'MX' },
];

// ==============================================================================
// META-SPECIFIC OPTIONS
// ==============================================================================

export const META_GENDER_OPTIONS = [
  { label: 'All Genders', value: 0 },
  { label: 'Male', value: 1 },
  { label: 'Female', value: 2 },
];

